import classNames from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import CartSummary from 'cart/CartSummary';
import Item from 'common/components/item/ItemForClubSubscriptionShipment';
import ItemNoEdit from 'common/components/item/ItemNoEdit';

import ClubShipDate from './ClubShipDate';
import ExchangeProductVariantModal from './ExchangeProductVariantModal';
import MinMaxProductMessage from './MinMaxProductMessage';
import { isShipmentAdjustable, listClubShipmentItems } from './helpers';

const ShipmentSummary = (props) => {
  const { clubSubscriptionShipment, club, isSummaryVisibleOnMobile } = props;
  const { virtualCart } = clubSubscriptionShipment;
  const settings = useSelector((state) => state.setting);

  const items = listClubShipmentItems(clubSubscriptionShipment, club);
  const [modal, setModal] = useState(null);
  const [exchangeProductVariantId, setExchangeProductVariantId] =
    useState(null);
  const itemCount = items.reduce((total, item) => total + item.quantity, 0);
  const isAdjustable = isShipmentAdjustable(clubSubscriptionShipment);
  const handleExchangeModal = (productVariantId) => {
    setExchangeProductVariantId(productVariantId);
    setModal('Exchange');
  };
  const handleCloseModal = () => {
    setModal(null);
    setExchangeProductVariantId(null);
  };

  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <div className="c7-checkout-summary__title c7-checkout-summary__title--hide-mobile">
        <ClubShipDate
          clubSubscriptionShipment={clubSubscriptionShipment}
          settings={settings}
        />
      </div>
      <div className="c7-checkout-summary__notes">
        <MinMaxProductMessage club={club} itemCount={itemCount} />
      </div>
      <div className="c7-cart-items c7-cart-items--club-shipment">
        {items.map((item) => {
          if (!isAdjustable) {
            return <ItemNoEdit item={item} key={item.id} settings={settings} />;
          }
          return (
            <Item
              item={item}
              club={club}
              clubSubscriptionShipment={clubSubscriptionShipment}
              key={item.id}
              onExchange={handleExchangeModal}
            />
          );
        })}
      </div>
      {virtualCart && <CartSummary cart={virtualCart} />}
      <div className="c7-checkout-summary__buttons">
        <a href="/profile/club-membership" className="c7-button">
          Return To Club Membership
        </a>
      </div>
      {renderModal(
        modal,
        handleCloseModal,
        exchangeProductVariantId,
        club,
        clubSubscriptionShipment
      )}
    </section>
  );
};

export default ShipmentSummary;

const renderModal = (
  modal,
  handleCloseModal,
  exchangeProductVariantId,
  club,
  clubSubscriptionShipment
) => {
  switch (modal) {
    case 'Exchange': {
      return (
        <ExchangeProductVariantModal
          onCloseModal={handleCloseModal}
          productVariantId={exchangeProductVariantId}
          club={club}
          clubSubscriptionShipment={clubSubscriptionShipment}
        />
      );
    }
    default: {
      return null;
    }
  }
};
